var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.25C1.48122 0.25 0.25 1.48122 0.25 3C0.25 4.51878 1.48122 5.75 3 5.75C4.51878 5.75 5.75 4.51878 5.75 3C5.75 1.48122 4.51878 0.25 3 0.25ZM1.75 3C1.75 2.30964 2.30964 1.75 3 1.75C3.69036 1.75 4.25 2.30964 4.25 3C4.25 3.69036 3.69036 4.25 3 4.25C2.30964 4.25 1.75 3.69036 1.75 3Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 7C0.25 6.58579 0.585786 6.25 1 6.25H5C5.41421 6.25 5.75 6.58579 5.75 7V20C5.75 20.4142 5.41421 20.75 5 20.75H1C0.585786 20.75 0.25 20.4142 0.25 20V7ZM1.75 7.75V19.25H4.25V7.75H1.75Z",
    fill: "#FFFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 7C7.25 6.58579 7.58579 6.25 8 6.25H12C12.4142 6.25 12.75 6.58579 12.75 7V7.43402L13.1853 7.24748C13.9336 6.92676 14.7339 6.72565 15.5433 6.65207C18.3182 6.3998 20.75 8.58038 20.75 11.3802V20C20.75 20.4142 20.4142 20.75 20 20.75H16C15.5858 20.75 15.25 20.4142 15.25 20V13C15.25 12.6685 15.1183 12.3505 14.8839 12.1161C14.6495 11.8817 14.3315 11.75 14 11.75C13.6685 11.75 13.3505 11.8817 13.1161 12.1161C12.8817 12.3505 12.75 12.6685 12.75 13V20C12.75 20.4142 12.4142 20.75 12 20.75H8C7.58579 20.75 7.25 20.4142 7.25 20V7ZM8.75 7.75V19.25H11.25V13C11.25 12.2707 11.5397 11.5712 12.0555 11.0555C12.5712 10.5397 13.2707 10.25 14 10.25C14.7293 10.25 15.4288 10.5397 15.9445 11.0555C16.4603 11.5712 16.75 12.2707 16.75 13V19.25H19.25V11.3802C19.25 9.47587 17.589 7.97227 15.6791 8.14591C15.025 8.20536 14.3784 8.36807 13.7762 8.6262L12.2954 9.26079C12.0637 9.3601 11.7976 9.33634 11.5871 9.19756C11.3767 9.05878 11.25 8.82354 11.25 8.57143V7.75H8.75Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.831537a0685520d5335192fb3fd9053c.svg";
export { ForwardRef as ReactComponent };